import { useCallback, useEffect, useState } from "react"
import { dataService } from "utils/dataService"
import { logger } from "utils/logger"

export const useIntakeQuestionsForInteraction = ({ interactionId }) => {
  const [questions, setQuestions] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // Resolves true when the questions were applied, false when the request failed.
  const fetchQuestions = useCallback(async (id) => {
    if (!id) {
      setQuestions([])
      setLoading(false)
      return true
    }
    setLoading(true)
    setError(null)
    try {
      const response = await dataService.IntakeQuestions.getForInteractionId({ interactionId: id })
      setQuestions(response?.data || [])
      return true
    } catch (err) {
      logger.error(`Failed to fetch intake questions for interaction ${id}`, err)
      setError(err)
      return false
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchQuestions(interactionId)
  }, [interactionId, fetchQuestions])

  const refetch = useCallback(() => fetchQuestions(interactionId), [interactionId, fetchQuestions])

  return { questions, loading, error, refetch }
}
